import React from 'react';
import { useQuery } from '../hooks/useQuery';
import Loading from '../common/Loading';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import da from 'date-fns/locale/da';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const FEEDBACKS = `
    query Feedbacks{
        feedbacks {
            id
            rating
            leasedByAB
            comment
            createdAt
            user {
                id
                name
            }
            dwelling {
                id
                location {
                    address
                  }
            }
        }
    }
`;

const Feedback = () => {
  const { data, loading, errors } = useQuery(FEEDBACKS, {});

  if (errors) {
    return (
      <>
        Der er sket en fejl
        <div>
          <pre>{JSON.stringify(errors, null, 2)}</pre>
        </div>
      </>
    );
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Rating</TableCell>
            <TableCell>Leased By AB</TableCell>
            <TableCell>comment</TableCell>
            <TableCell>User</TableCell>
            <TableCell>Dwelling</TableCell>
            <TableCell>Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.feedbacks.map((feedback) => {
            return (
              <TableRow key={feedback.id}>
                <TableCell>{feedback.rating}</TableCell>
                <TableCell>{feedback.leasedByAB}</TableCell>
                <TableCell>{feedback.comment}</TableCell>
                <TableCell>{feedback.user.name}</TableCell>
                <TableCell>
                  {feedback.dwelling ? (
                    <Link to={`/dwellings/${feedback.dwelling.id}/preview`}>
                      {feedback.dwelling.location.address}
                    </Link>
                  ) : (
                    ''
                  )}
                </TableCell>
                <TableCell>
                  {format(new Date(feedback.createdAt), 'dd MMMM yyyy HH:mm', {
                    locale: da
                  })}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default Feedback;